module.exports = __webpack_public_path__ + "static/presentation-d26354cb8b9dd21d95fe009566bfa66d.mp4";